import { ErrorMessageContents } from '../../helpers/hub'
import { PassiveOrder } from './types'

export const fetchPassiveOrders = () =>
  ({ type: 'passiveOrders.fetchPassiveOrders' } as const)
type FetchPassiveOrdersAction = ReturnType<typeof fetchPassiveOrders>

export const unsubscribePassiveOrders = () =>
  ({ type: 'passiveOrders.unsubscribePassiveOrders' } as const)
type UnsubscribePassiveOrdersAction = ReturnType<
  typeof unsubscribePassiveOrders
>

export const clearPassiveOrders = () =>
  ({ type: 'passiveOrders.clearPassiveOrders' } as const)
export type ClearPassiveOrdersAction = ReturnType<typeof clearPassiveOrders>

export const addOrUpdatePassiveOrders = (orders: PassiveOrder[]) =>
  ({ type: 'passiveOrders.addOrUpdatePassiveOrders', payload: orders } as const)
export type AddOrUpdatePassiveOrdersAction = ReturnType<
  typeof addOrUpdatePassiveOrders
>

export const cancelPassiveOrder = (orderId: string) =>
  ({ type: 'passiveOrders.cancelPassiveOrder', payload: orderId } as const)
export type CancelPassiveOrderAction = ReturnType<typeof cancelPassiveOrder>

export const cancelPassiveOrderFailure = (orderId: string, failure: string) =>
  ({
    type: 'passiveOrders.cancelPassiveOrderFailure',
    payload: { orderId, failure }
  } as const)
export type CancelPassiveOrderFailureAction = ReturnType<
  typeof cancelPassiveOrderFailure
>

export const createOrderFromPassiveOrder = (orderId: number) =>
  ({
    type: 'passiveOrders.createOrderFromPassiveOrder',
    payload: { orderId }
  } as const)
export type CreateOrderFromPassiveOrderAction = ReturnType<
  typeof createOrderFromPassiveOrder
>

export const createOrderFromPassiveOrderSuccess = () =>
  ({ type: 'passiveOrders.createOrderFromPassiveOrderSuccess' } as const)
export type CreateOrderFromPassiveOrderSuccess = ReturnType<
  typeof createOrderFromPassiveOrderSuccess
>

export const handleCreateOrderFromPassiveOrderError = (
  err: string,
  orderId: number
) =>
  ({
    type: 'passiveOrders.createOrderFromPassiveOrderError',
    payload: { err, orderId }
  } as const)
export type CreateOrderFromPassiveOrderErrorAction = ReturnType<
  typeof handleCreateOrderFromPassiveOrderError
>

export const fetchPassiveOrdersError = (error: ErrorMessageContents) =>
  ({
    type: 'passiveOrders.fetchPassiveOrdersError',
    payload: error,
    error: true
  } as const)
type FetchPassiveOrdersErrorAction = ReturnType<typeof fetchPassiveOrdersError>

export type PassiveOrdersAction =
  | FetchPassiveOrdersAction
  | FetchPassiveOrdersErrorAction
  | AddOrUpdatePassiveOrdersAction
  | UnsubscribePassiveOrdersAction
  | ClearPassiveOrdersAction
  | CancelPassiveOrderAction
  | CancelPassiveOrderFailureAction
  | CreateOrderFromPassiveOrderErrorAction
  | CreateOrderFromPassiveOrderSuccess
  | CreateOrderFromPassiveOrderAction
